var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-input',{class:_vm.inputClass,attrs:{"disabled":_vm.disabled,"state":_vm.state,"title":_vm.inputTitle,"placeholder":_vm.placeholder},on:{"blur":_vm.blurred,"focus":function($event){_vm.isInputActive = true}},model:{value:(_vm.displayValue),callback:function ($$v) {_vm.displayValue=$$v},expression:"displayValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }